(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['../ApiClient', './BlobLocation', './Grade'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./BlobLocation'), require('./Grade'));
  } else {
    // Browser globals (root is window)
    if (!root.SmartCsV2Sdk) {
      root.SmartCsV2Sdk = {};
    }
    root.SmartCsV2Sdk.App = factory(root.SmartCsV2Sdk.ApiClient, root.SmartCsV2Sdk.BlobLocation, root.SmartCsV2Sdk.Grade);
  }
}(this, function(ApiClient, BlobLocation, Grade) {
  'use strict';

  /**
   * The App model module.
   * @module model/App
   * @version 2.0.624
   */

  /**
   * Constructs a new <code>App</code>.
   * @alias module:model/App
   * @class
   */
  var exports = function() {
























  };

  /**
   * Constructs a <code>App</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/App} obj Optional instance to populate.
   * @return {module:model/App} The populated <code>App</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) { 
      obj = obj || new exports();

      if (data.hasOwnProperty('apkBlobLocation')) {
        obj['apkBlobLocation'] = BlobLocation.constructFromObject(data['apkBlobLocation']);
      }
      if (data.hasOwnProperty('appSize')) {
        obj['appSize'] = ApiClient.convertToType(data['appSize'], 'Integer');
      }
      if (data.hasOwnProperty('appType')) {
        obj['appType'] = ApiClient.convertToType(data['appType'], 'String');
      }
      if (data.hasOwnProperty('appVersion')) {
        obj['appVersion'] = ApiClient.convertToType(data['appVersion'], 'String');
      }
      if (data.hasOwnProperty('categoryIds')) {
        obj['categoryIds'] = ApiClient.convertToType(data['categoryIds'], ['String']);
      }
      if (data.hasOwnProperty('created')) {
        obj['created'] = ApiClient.convertToType(data['created'], 'Date');
      }
      if (data.hasOwnProperty('deleted')) {
        obj['deleted'] = ApiClient.convertToType(data['deleted'], 'Boolean');
      }
      if (data.hasOwnProperty('description')) {
        obj['description'] = ApiClient.convertToType(data['description'], 'String');
      }
      if (data.hasOwnProperty('grade')) {
        obj['grade'] = Grade.constructFromObject(data['grade']);
      }
      if (data.hasOwnProperty('iconBlobLocation')) {
        obj['iconBlobLocation'] = BlobLocation.constructFromObject(data['iconBlobLocation']);
      }
      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('imageBlobLocation')) {
        obj['imageBlobLocation'] = BlobLocation.constructFromObject(data['imageBlobLocation']);
      }
      if (data.hasOwnProperty('industry')) {
        obj['industry'] = ApiClient.convertToType(data['industry'], 'String');
      }
      if (data.hasOwnProperty('locales')) {
        obj['locales'] = ApiClient.convertToType(data['locales'], ['String']);
      }
      if (data.hasOwnProperty('minSdkVersion')) {
        obj['minSdkVersion'] = ApiClient.convertToType(data['minSdkVersion'], 'Integer');
      }
      if (data.hasOwnProperty('packageName')) {
        obj['packageName'] = ApiClient.convertToType(data['packageName'], 'String');
      }
      if (data.hasOwnProperty('platform')) {
        obj['platform'] = ApiClient.convertToType(data['platform'], 'String');
      }
      if (data.hasOwnProperty('popularity')) {
        obj['popularity'] = ApiClient.convertToType(data['popularity'], 'Integer');
      }
      if (data.hasOwnProperty('subjects')) {
        obj['subjects'] = ApiClient.convertToType(data['subjects'], ['String']);
      }
      if (data.hasOwnProperty('title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
      if (data.hasOwnProperty('updated')) {
        obj['updated'] = ApiClient.convertToType(data['updated'], 'Date');
      }
      if (data.hasOwnProperty('url')) {
        obj['url'] = ApiClient.convertToType(data['url'], 'String');
      }
      if (data.hasOwnProperty('versionCode')) {
        obj['versionCode'] = ApiClient.convertToType(data['versionCode'], 'Integer');
      }
    }
    return obj;
  }


  /**
   * @member {module:model/BlobLocation} apkBlobLocation
   */
  exports.prototype['apkBlobLocation'] = undefined;

  /**
   * @member {Integer} appSize
   */
  exports.prototype['appSize'] = undefined;

  /**
   * @member {module:model/App.AppTypeEnum} appType
   */
  exports.prototype['appType'] = undefined;

  /**
   * @member {String} appVersion
   */
  exports.prototype['appVersion'] = undefined;

  /**
   * @member {Array.<String>} categoryIds
   */
  exports.prototype['categoryIds'] = undefined;

  /**
   * @member {Date} created
   */
  exports.prototype['created'] = undefined;

  /**
   * @member {Boolean} deleted
   */
  exports.prototype['deleted'] = undefined;

  /**
   * @member {String} description
   */
  exports.prototype['description'] = undefined;

  /**
   * @member {module:model/Grade} grade
   */
  exports.prototype['grade'] = undefined;

  /**
   * @member {module:model/BlobLocation} iconBlobLocation
   */
  exports.prototype['iconBlobLocation'] = undefined;

  /**
   * @member {String} id
   */
  exports.prototype['id'] = undefined;

  /**
   * @member {module:model/BlobLocation} imageBlobLocation
   */
  exports.prototype['imageBlobLocation'] = undefined;

  /**
   * @member {module:model/App.IndustryEnum} industry
   */
  exports.prototype['industry'] = undefined;

  /**
   * @member {Array.<module:model/App.LocalesEnum>} locales
   */
  exports.prototype['locales'] = undefined;

  /**
   * @member {Integer} minSdkVersion
   */
  exports.prototype['minSdkVersion'] = undefined;

  /**
   * @member {String} packageName
   */
  exports.prototype['packageName'] = undefined;

  /**
   * @member {module:model/App.PlatformEnum} platform
   */
  exports.prototype['platform'] = undefined;

  /**
   * @member {Integer} popularity
   */
  exports.prototype['popularity'] = undefined;

  /**
   * @member {Array.<String>} subjects
   */
  exports.prototype['subjects'] = undefined;

  /**
   * @member {String} title
   */
  exports.prototype['title'] = undefined;

  /**
   * @member {Date} updated
   */
  exports.prototype['updated'] = undefined;

  /**
   * @member {String} url
   */
  exports.prototype['url'] = undefined;

  /**
   * @member {Integer} versionCode
   */
  exports.prototype['versionCode'] = undefined;


  /**
   * Allowed values for the <code>appType</code> property.
   * @enum {String}
   * @readonly
   */
  exports.AppTypeEnum = { 
    /**
     * value: PUBLIC
     * @const
     */
    PUBLIC: "PUBLIC",
    
    /**
     * value: PRIVATE
     * @const
     */
    PRIVATE: "PRIVATE"
  };  /**
   * Allowed values for the <code>industry</code> property.
   * @enum {String}
   * @readonly
   */
  exports.IndustryEnum = { 
    /**
     * value: EDU
     * @const
     */
    EDU: "EDU",
    
    /**
     * value: ENT
     * @const
     */
    ENT: "ENT"
  };
  /**
   * Allowed values for the <code>locales</code> property.
   * @enum {String}
   * @readonly
   */
  exports.LocalesEnum = { 
    /**
     * value: DE_DE
     * @const
     */
    DE_DE: "DE_DE",
    
    /**
     * value: DE_CH
     * @const
     */
    DE_CH: "DE_CH",
    
    /**
     * value: EN_US
     * @const
     */
    EN_US: "EN_US",
    
    /**
     * value: EN_CA
     * @const
     */
    EN_CA: "EN_CA",
    
    /**
     * value: EN_UK
     * @const
     */
    EN_UK: "EN_UK",
    
    /**
     * value: EN_GB
     * @const
     */
    EN_GB: "EN_GB",
    
    /**
     * value: EN_AU
     * @const
     */
    EN_AU: "EN_AU",
    
    /**
     * value: EN_NZ
     * @const
     */
    EN_NZ: "EN_NZ",
    
    /**
     * value: ES_ES
     * @const
     */
    ES_ES: "ES_ES",
    
    /**
     * value: ES_MX
     * @const
     */
    ES_MX: "ES_MX",
    
    /**
     * value: ES_CO
     * @const
     */
    ES_CO: "ES_CO",
    
    /**
     * value: ES_GT
     * @const
     */
    ES_GT: "ES_GT",
    
    /**
     * value: FR_CA
     * @const
     */
    FR_CA: "FR_CA",
    
    /**
     * value: FR_FR
     * @const
     */
    FR_FR: "FR_FR",
    
    /**
     * value: FR_BE
     * @const
     */
    FR_BE: "FR_BE",
    
    /**
     * value: FR_CH
     * @const
     */
    FR_CH: "FR_CH",
    
    /**
     * value: IT_IT
     * @const
     */
    IT_IT: "IT_IT",
    
    /**
     * value: JA_JP
     * @const
     */
    JA_JP: "JA_JP",
    
    /**
     * value: KO_KR
     * @const
     */
    KO_KR: "KO_KR",
    
    /**
     * value: LV_LV
     * @const
     */
    LV_LV: "LV_LV",
    
    /**
     * value: NB_NO
     * @const
     */
    NB_NO: "NB_NO",
    
    /**
     * value: FI_FI
     * @const
     */
    FI_FI: "FI_FI",
    
    /**
     * value: DA_DK
     * @const
     */
    DA_DK: "DA_DK",
    
    /**
     * value: NL_BE
     * @const
     */
    NL_BE: "NL_BE",
    
    /**
     * value: NL_NL
     * @const
     */
    NL_NL: "NL_NL",
    
    /**
     * value: RU_RU
     * @const
     */
    RU_RU: "RU_RU",
    
    /**
     * value: SV_SE
     * @const
     */
    SV_SE: "SV_SE",
    
    /**
     * value: ZH_CN
     * @const
     */
    ZH_CN: "ZH_CN",
    
    /**
     * value: ZH_TW
     * @const
     */
    ZH_TW: "ZH_TW",
    
    /**
     * value: ZH_HK
     * @const
     */
    ZH_HK: "ZH_HK",
    
    /**
     * value: CY_GB
     * @const
     */
    CY_GB: "CY_GB",
    
    /**
     * value: ET_EE
     * @const
     */
    ET_EE: "ET_EE",
    
    /**
     * value: LT_LT
     * @const
     */
    LT_LT: "LT_LT",
    
    /**
     * value: HU_HU
     * @const
     */
    HU_HU: "HU_HU",
    
    /**
     * value: PL_PL
     * @const
     */
    PL_PL: "PL_PL",
    
    /**
     * value: PT_PT
     * @const
     */
    PT_PT: "PT_PT",
    
    /**
     * value: RO_RO
     * @const
     */
    RO_RO: "RO_RO",
    
    /**
     * value: SK_SK
     * @const
     */
    SK_SK: "SK_SK",
    
    /**
     * value: SL_SI
     * @const
     */
    SL_SI: "SL_SI",
    
    /**
     * value: VI_VN
     * @const
     */
    VI_VN: "VI_VN",
    
    /**
     * value: TR_TR
     * @const
     */
    TR_TR: "TR_TR",
    
    /**
     * value: CS_CZ
     * @const
     */
    CS_CZ: "CS_CZ",
    
    /**
     * value: EL_GR
     * @const
     */
    EL_GR: "EL_GR",
    
    /**
     * value: UK_UA
     * @const
     */
    UK_UA: "UK_UA"
  };  /**
   * Allowed values for the <code>platform</code> property.
   * @enum {String}
   * @readonly
   */
  exports.PlatformEnum = { 
    /**
     * value: WEB
     * @const
     */
    WEB: "WEB",
    
    /**
     * value: ANDROID
     * @const
     */
    ANDROID: "ANDROID"
  };

  return exports;
}));
